import React from "react"
import { Container } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import PermissionTable from "./permissionTable"

const Permissions = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Permissions"} breadcrumbItem={"Permissions"} />
          <PermissionTable />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Permissions
